export default "__VITE_ASSET__BHYtB9IQ__"